import React, { createContext, useContext, useMemo, useState } from "react";

const FormContext = createContext(null);

const initialState = {
  name: "",
  dob: { year: "", month: "", day: "" },
  birthTime: { hour: "", minute: "", meridiem: "" },
  birthTimeConfidence: "",
  location: "",
  locationData: null,   // { lat, lon, displayName, timezone }
  email: "",
  focusArea: "",
  landingVariant: "vedic-timeline-v1",
  serviceEmailConsent: false,
  marketingConsent: false
};

export function FormProvider({ children }) {
  const [formData, setFormData] = useState(initialState);

  const api = useMemo(() => ({
    formData,
    setFormData,
    reset: () => setFormData(initialState)
  }), [formData]);

  return <FormContext.Provider value={api}>{children}</FormContext.Provider>;
}

export function useForm() {
  const ctx = useContext(FormContext);
  if (!ctx) throw new Error("useForm must be used within FormProvider");
  return ctx;
}
